import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MonitoringService } from '../utility/monitoring/monitoring.service';
import {UrlControllerService} from '../url-controller.service';
import {Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';

@Injectable({
  providedIn: 'root',
})
export class TranslateService extends UrlControllerService {

  private _languageJSON: any;

  private _languageTransalteJSON: any;

  private _sendingTranslation = false;

  private _webHook =
    'https://hooks.slack.com/services/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';

  languages: any[] = [];

  languagesTrans: any[] = [];

  resources: any[] = [];

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private authentication: AuthenticationService,
    private monitoringService: MonitoringService,
  public _store: Store<IAppState>
  ) {
    super(_store);
  }

  get languageJSON(): any {
    return this._languageJSON;
  }

  get languageTransalteJSON(): any {
    return this._languageTransalteJSON;
  }

  set languageTransalteJSON(languageTransalteJSON: any) {
    this._languageTransalteJSON = languageTransalteJSON;
  }

  get sendingTranslation(): boolean {
    return this._sendingTranslation;
  }

  set sendingTranslation(sendingTranslation: boolean) {
    this._sendingTranslation = sendingTranslation;
  }

  getDropLanguage() {
    let user: string;
    let token: string;
    if (!this.authentication.user) {
      user = 'cesare';
      token = '9f90a865bfb83943918629513c450ff1';
    } else {
      user = this.authentication.user.Username;
      token = this.authentication.user.Token;
    }
    this.http
      .get(`${this.apiUrlSelected}rest/locale/languages/${user}/${token}`)
      .pipe(
        map((x: any) => x.languages.filter((y) => y.show === '1')),

        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('getLanguage', null)) // then handle the error
      )
      .subscribe((data: any) => {
        this.languages = data;
      });
  }

  getDropLanguageTrans() {
    let user = '';
    let token = '';
    if (this.authentication.user) {
      user = this.authentication.user.Username;
      token = this.authentication.user.Token;
    }
    this.http
      .get(`${this.apiUrlSelected}rest/locale/languages/${user}/${token}`)
      .pipe(
        map((x: any) => x.languages.filter((y) => y.modify === '1')),

        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('getLanguage', null)) // then handle the error
      )
      .subscribe((data: any) => {
        this.languagesTrans = data;
      });
  }

  getDropResource() {
    this.http
      .get(`${this.apiUrlSelected}rest/locale/resources`)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('getResource', null)) // then handle the error
      )
      .subscribe((data: any) => {
        this.resources = data.resources;
      });
  }

  saveItem(obj: any): Observable<any> {
    return this.http
      .post<any>(`${this.apiUrlSelected}rest/locale/item/add`, obj)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('saveItem', null)) // then handle the error
      );
  }

  deteleItem(resource: string, group: string, chiave: string, language: string): Observable<any> {
    return this.http
      .get(`${this.apiUrlSelected}rest/locale/item/del/${resource}/${group}/${chiave}/${language}`)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('getResource', null)) // then handle the error
      );
  }

  saveGroup(obj: any): Observable<any> {
    return this.http
      .post<any>(`${this.apiUrlSelected}rest/locale/group/add`, obj)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('saveGroup', null)) // then handle the error
      );
  }

  deteleGroup(resource: string, group: string): Observable<any> {
    return this.http
      .get(`${this.apiUrlSelected}rest/locale/group/del/${resource}/${group}`)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('delGroup', null)) // then handle the error
      );
  }

  getLanguageTranslate(resource: string, language: string): Observable<any> {
    return this.http
      .get(`${this.apiUrlSelected}rest/locale/resource/get/${resource}/${language}`)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('getLanguage', null)) // then handle the error
      );
  }

  getUrlTranslate(resource: string, language: string, type: string): string {
    if (type === 'json') {
      return this.apiUrlSelected + 'rest/locale/resource/get/' + resource + '/' + language;
    }
    if (type === 'resx') {
      return this.apiUrlSelected + 'rest/locale/resource/resx/' + resource + '/' + language;
    }
  }

  sentToSlack() {
    this._sendingTranslation = true;
    const message = {
      text: JSON.stringify(this.languageTransalteJSON),
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    httpOptions['responseType'] = 'text';
    this.http
      .post<any>(this._webHook, message, httpOptions)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('senSlack', null)) // then handle the error
      )
      .subscribe((data: any) => {
        this._sendingTranslation = false;
        this.promptUser(data);
      });
  }

  private promptUser(data): void {
    let message = '';
    if (data.code === 1024) {
      message = `${data.description} Data sent`;
    } else {
      message = `${data.description} Problem sending data`;
    }

    const snackBarRef = this.snackBar.open(
      message,
      'OK',

      {
        horizontalPosition: 'right',
        verticalPosition: 'top',
      }
    );
    snackBarRef.onAction().subscribe();
  }
}
